import React, {useCallback, useEffect, useState, useImperativeHandle} from 'react';
import {isMobile} from 'react-device-detect';
import {useHistory} from 'react-router-dom';
import {useFormik} from 'formik';
import * as Yup from 'yup';

import {areEqual, isEmptyObject} from '../../../../helpers';
import {BottomSheet} from '../../../../components/organisms';
import {strings} from '../../../../assets';
import {Mask} from '@tboerc/maskfy';
import dayjs from 'dayjs';

const CALLER = 'PAGAMENTO';

const PARCELAS = [{qtn: 10}, {qtn: 9}, {qtn: 8}, {qtn: 7}, {qtn: 6}, {qtn: 5}, {qtn: 4}, {qtn: 3}, {qtn: 2}, {qtn: 1}];

const INITIAL_VALUES = {
  numero_parcelas: '6',
  data_vencimento: 5,
};

const somarTotal = (bicicletas) => {
  let totalFinal = 0;

  bicicletas.forEach((bike) => {
    let total = 0;
    bike.coberturas.forEach((cob) => {
      total += parseFloat(cob.valor);
    });

    if (bike.modalidade_bicicleta.id === 6 && total < 536.9) {
      total = 536.9;
    } else if (bike.modalidade_bicicleta.id === 7 && total < 268.45) {
      total = 268.45;
    } else if ((bike.modalidade_bicicleta.id === 8 || bike.modalidade_bicicleta.id === 9) && total < 375.83) {
      total = 375.83;
    }

    totalFinal += total;
  });

  return totalFinal;
};

const Pagamento = ({current, position, checkAdvance, extraData, corPrimaria}) => {
  const [visible, setVisible] = useState(false);
  const [visible2, setVisible2] = useState(false);
  const history = useHistory();

  const isModal = extraData.segurado.segurado_bicicletas[0].modalidade_bicicleta.id <= 5 ? false : true;

  useImperativeHandle(ref, () => ({values: () => ({caller: CALLER, data: {pagamento: values}})}));

  const toggle = useCallback(() => setVisible(!visible), [visible, setVisible]);
  const toggle2 = useCallback(() => setVisible2(!visible2), [visible2, setVisible2]);

  const {setFieldValue, errors, values} = useFormik({
    initialValues: INITIAL_VALUES,
    validationSchema: validationSchema,
    initialErrors: strings.INITIAL_ERRORS,
  });

  useEffect(() => {
    if (extraData.segurado.id_projeto === 5 && values.numero_parcelas === '6') setFieldValue('numero_parcelas', 4, true);
  });

  const onModalidadeClick = useCallback(
    (val) => () => {
      setFieldValue('numero_parcelas', val, true);
      toggle();
    },
    [toggle, setFieldValue],
  );

  const onVencimentoClick = useCallback(
    (val) => () => {
      setFieldValue('data_vencimento', val, true);
      toggle2();
    },
    [toggle2, setFieldValue],
  );

  useEffect(() => {
    if (current === position) checkAdvance({caller: CALLER, status: isEmptyObject(errors)});
  });

  useEffect(() => {
    if (!isMobile) history.replace('corretor/erro');
  }, [history]);

  let total = somarTotal(extraData.segurado.segurado_bicicletas);

  total = extraData.segurado.cupom
    ? extraData.segurado.cupom.tipo_desconto === 0
      ? parseFloat(total - (total * extraData.segurado.cupom.valor_desconto) / 100).toFixed(2)
      : parseFloat(total - extraData.segurado.cupom.valor_desconto).toFixed(2)
    : total;

  const DESCONTO = extraData.segurado.segurado_bicicletas
    ? extraData.segurado.segurado_bicicletas.length >= 2
      ? extraData.segurado.segurado_bicicletas.length >= 2 && extraData.segurado.segurado_bicicletas.length <= 3
        ? 15
        : 25
      : 0
    : 0;

  return (
    <div>
      <div className="mobileContent">
        <h1 style={{color: !!corPrimaria ? corPrimaria : '#023a86'}}>Informações de pagamento</h1>

        <p>
          {isModal
            ? 'Informe a quantidade de parcelas que deseja pagar o seu seguro, o pagamento será realizado via boletos bancário a serem encaminhados para seu e-mail cadastrado após análise da Seguradora e emissão da sua apólice de seguro. Lembramos que o valor do seguro poderá sofrer alterações após análise da Seguradora, com base nas informações que você utilizou para realizar a cotação e a análise das fotos e Nota Fiscal de seu equipamento'
            : 'Informe a quantidade de parcelas que deseja pagar o seu seguro, o pagamento será realizado via boletos bancário a serem encaminhados para seu e-mail cadastrado após análise da Seguradora e emissão da sua apólice de seguro. Lembramos que o valor do seguro poderá sofrer alterações após análise da Seguradora, com base nas informações que você utilizou para realizar a cotação e a análise das fotos e Nota Fiscal de sua bicicleta'}
        </p>

        <div className="toastValue">
          <p style={{color: !!corPrimaria ? corPrimaria : '#023a86'}}>Valor total do seguro</p>
          <span style={{color: !!corPrimaria ? corPrimaria : '#023a86'}}>
            {Mask.money.value(parseFloat(total - total * (DESCONTO / 100)).toFixed(2))}
          </span>
        </div>

        <div className="paymentInfos">
          <button tabIndex={-1} onClick={toggle} style={{background: !!corPrimaria ? corPrimaria : '#023a86'}}>
            <p>Parcelas</p>
            <span>
              {values.numero_parcelas} parcelas <img alt="edit" src="../assets/img/edit.png" className="ml-2" width="25" />
            </span>
          </button>
          <button tabIndex={-1}>
            <p>Valor por parcela</p>
            <span style={{color: !!corPrimaria ? corPrimaria : '#023a86'}}>
              {Mask.money.value(
                parseFloat(
                  total -
                    (extraData.segurado.id_projeto === 5 && values.numero_parcelas === 1
                      ? total * (3 / 100)
                      : total * (DESCONTO / 100)),
                ).toFixed(2) / +values.numero_parcelas,
              )}
            </span>
          </button>
        </div>
        {extraData.segurado.id_projeto === 5 && (
          <p style={{textAlign: 'center', width: '100%', marginTop: '-5rem'}}>Pague a vista com 3% de desconto</p>
        )}
      </div>

      <div className="paymentInfosButtom">
        <button tabIndex={-1} onClick={toggle2}>
          <p>Dia para vencimento da(s) parcela(s)</p>
          <span>
            {values.data_vencimento} <img alt="edit" src="../assets/img/edit.png" className="ml-2" width="25" />
          </span>
        </button>
      </div>

      <BottomSheet visible={visible} onRequestClose={toggle} title={'Selecione a quantidade de parcelas'}>
        {PARCELAS.map(({qtn}, index, array) => (
          <>
            {extraData.segurado.id_projeto === 5 && qtn > 4 ? null : (
              <span
                key={'bt_' + qtn}
                onClick={onModalidadeClick(qtn)}
                className={`py-3 text-center border-top user-select-none ${index === array.length && 'border-bottom'}`}>
                {qtn + 'X'}
              </span>
            )}
          </>
        ))}
      </BottomSheet>

      <BottomSheet
        visible={visible2}
        onRequestClose={toggle2}
        title={'Selecione o melhor dia para o vencimento da(s) parcela(s)'}>
        {[...Array(30)].map((x, i) => (
          <>
            <span
              key={i}
              onClick={onVencimentoClick(i + 1)}
              className={`py-3 text-center border-top user-select-none ${i === 10 && 'border-bottom'}`}>
              {i + 1}
            </span>
          </>
        ))}
      </BottomSheet>
    </div>
  );
};

const validationSchema = Yup.object().shape({
  numero_parcelas: Yup.string().required(strings.required),
});

export default React.memo(Pagamento, areEqual());
export const ref = React.createRef();
